import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '../../components';
import { EditListingPricingForm } from '../../forms';
import { ensureOwnListing } from '../../util/data';
import { getDefaultTimeZoneOnBrowser } from '../../util/dates';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  Modal,
} from '../../components';
import config from '../../config';

import css from './EditListingPricingPanel.css';

const { Money } = sdkTypes;

const defaultTimeZone = () =>
  typeof window !== 'undefined' ? getDefaultTimeZoneOnBrowser() : 'Etc/UTC';

const EditListingPricingPanel = props => {
  const [modalOpen, setModalOpen] = useState(false)

  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { price, publicData } = currentListing.attributes;

  const availabilityPlan = currentListing && currentListing.attributes.availabilityPlan;
  const isAvailabilityPlan =
    availabilityPlan && availabilityPlan.entries && availabilityPlan.entries.length > 0
  const category = publicData.category ? publicData.category[0] : null;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingPricingPanel.title"
      values={{ listingTitle: <ListingLink listing={listing} /> }}
    />
  ) : (
    <FormattedMessage id="EditListingPricingPanel.createListingTitle" />
  );

  const numberOfGuestsFrom = publicData && publicData.numberOfGuestsFrom;
  const numberOfGuestsTo = publicData && publicData.numberOfGuestsTo;
  const dataDuration = publicData && publicData.duration;

  const priceCurrencyValid = price instanceof Money ? price.currency === config.currency : true;
  const form = priceCurrencyValid ? (
    <EditListingPricingForm
      className={css.form}
      publicData={publicData}
      initialValues={{ price, numberOfGuestsFrom, numberOfGuestsTo, duration: dataDuration }}
      onSubmit={values => {
        const { price, numberOfGuestsFrom, numberOfGuestsTo, duration } = values;
        const updateValues = {
          price,
          publicData: {
            // numberOfGuestsFrom,
            // numberOfGuestsTo,
            duration,
          },
        };

        // If the duration has been changed, clear the availability
        // 
        // if (duration !== dataDuration && isAvailabilityPlan) {
        //   setModalOpen(true);
        //   updateValues.availabilityPlan = {
        //     type: 'availability-plan/time',
        //     timezone: defaultTimeZone(),
        //     entries: [],
        //   };
        // }

        // isAvailabilityPlan
        //   ? setTimeout(() => {
        //       setModalOpen(false);
        //       onSubmit(updateValues);
        //     }, 2500)
        //   : onSubmit(updateValues);
          
        onSubmit(updateValues);
      }}
      onChange={onChange}
      saveActionMsg={submitButtonText}
      disabled={disabled}
      ready={ready}
      updated={panelUpdated}
      updateInProgress={updateInProgress}
      fetchErrors={errors}
      duration={config.custom.duration}
      category={category}
    />
  ) : (
    <div className={css.priceCurrencyInvalid}>
      <FormattedMessage id="EditListingPricingPanel.listingPriceCurrencyInvalid" />
    </div>
  );

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      {form}
      <Modal
        id="EditListingPricingPanel"
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onManageDisableScrolling={() => null}
      >
        <p>
          <FormattedMessage id="EditListingPricingPanel.durationChanged" />
        </p>
      </Modal>
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingPricingPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingPricingPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingPricingPanel;
